// src/pages/About.js
import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const About = () => {
  return (
    <section
      className="about-section"
      style={{ padding: "4rem 0", backgroundColor: "#f7f7f7" }}
    >
      <Container>
        <h2 className="text-center">Sobre Nós</h2>
        <Row className="mt-4 align-items-center">
          <Col md={6}>
            <img
              src="/assets/5.png"
              alt="Amarante PetShop"
              style={{
                width: "100%",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              }}
            />
          </Col>
          <Col md={6}>
            <p
              style={{ marginBottom: "1rem", lineHeight: "1.6", color: "#333" }}
            >
              O Amarante PetShop foi fundado com o objetivo de oferecer o melhor
              em cuidados para os seus pets. Somos uma equipe apaixonada por
              animais, comprometida em proporcionar produtos de qualidade e
              serviços excepcionais que atendam às necessidades do seu
              companheiro.
            </p>
            <p
              style={{ marginBottom: "1rem", lineHeight: "1.6", color: "#333" }}
            >
              Nossa missão é ser o parceiro de confiança para todos os donos de
              pets, oferecendo uma ampla variedade de rações, brinquedos,
              acessórios e serviços como banho e tosa, sempre com muito carinho
              e atenção.
            </p>
            <p
              style={{ marginBottom: "1rem", lineHeight: "1.6", color: "#333" }}
            >
              Estamos localizados em São Gonçado do Amarante/RN e atendemos toda
              a região com entrega rápida e eficiente. Venha nos visitar e
              conheça tudo o que temos a oferecer para o seu pet!
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
